import { IconWarning } from '@americanexpress/dls-icons';
import { Heading, Surface } from '@americanexpress/dls-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const SystemError = () => (
  <Surface variant="foreground">
    <div className="flex flex-column flex-align-items-center pad-3-lg-up pad-2">
      <IconWarning size="xl" isFilled={true} color="critical" />
      <Heading className="margin-2-t margin-3-t-lg-up" level={2} variant="sans-medium-bold">
        <FormattedMessage
          id="CidSystemError-header"
          defaultMessage="Our System is not Responding"
        />
      </Heading>
      <p className="margin-2-tb">
        <FormattedMessage
          id="CidSystemError-desc"
          defaultMessage="You may experience intermittent delays. We apologize for this inconvenience."
        />
      </p>
      <hr />
      <p className="flex-align-self-start margin-2-tb">
        <FormattedMessage
          id="CidSystemError-action"
          defaultMessage="While we are working to correct the problem, you can:"
        />
      </p>
      <ul className="flex-align-self-start margin-b">
        <li>
          <FormattedMessage
            id="CidSystemError-listOne"
            defaultMessage="Try again by hitting the Refresh or Reload buttons on your web browser."
          />
        </li>
        <li>
          <FormattedMessage
            id="CidSystemError-listTwo"
            defaultMessage="Try your request again later today."
          />
        </li>
      </ul>
      <p className="flex-align-self-start">
        <FormattedMessage
          id="CidSystemError-thanks"
          defaultMessage="Thank you."
        />
      </p>
    </div>
  </Surface>
);

export default SystemError;
